export const UNUSED_MICROSOFT_TAGS_REGEXP = /<!--[\s\S]*?-->/g
